import React from 'react'
import { Toast } from 'antd-mobile-v5'
import { CloseOutline } from 'antd-mobile-icons'

export function ClosableToast({ content, duration = 3000 }) {
  let toastRef = null

  const show = () => {
    toastRef = Toast.show({
      content: (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
          <span>{content}</span>
          <CloseOutline fontSize={26} onClick={close} />
        </div>
      ),
      duration,
    })
  }

  const close = () => {
    Toast.clear()
  }

  return { show, close }
}
